import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const OperationalArea = z.object({
  id: z.string(),
  name: z.string(),
  subArea: z.array(z.object({ id: z.string(), name: z.string() })),
  responsible: z.array(PersonaInfoSummary),
  openCall: z.number()
})

export const OperationalListArea = z.array(OperationalArea)
export type OperationalArea = z.infer<typeof OperationalArea>
export type OperationalListArea = z.infer<typeof OperationalListArea>
